import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTextField-root': {
      width: 230,
      minWidth: 230,
      margin: 0
    },
    '& .MuiOutlinedInput-input': {
      height: 'auto',
      paddingTop: theme.spacing(1.375),
      paddingBottom: theme.spacing(1.375)
    }
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.5
  }
}));
